var map = {
	"./abtrip.png": "0953",
	"./abtrip_web.png": "8cf7",
	"./bsh.png": "c5aa",
	"./bsh_web.png": "5c96",
	"./concung.png": "3ff8",
	"./concung_web.png": "40ee",
	"./highland.png": "1ad5",
	"./highland_web.png": "853d",
	"./mb.png": "3301",
	"./mb_web.png": "2b4e",
	"./mbal.png": "152c",
	"./mbal_web.png": "5309",
	"./ocb.png": "d890",
	"./ocb_web.png": "7ab6",
	"./routine.png": "22ae",
	"./routine_web.png": "ddb7",
	"./shopee.png": "395a",
	"./shopee_web.png": "21ed",
	"./tiki.png": "8a17",
	"./tiki_web.png": "14b6",
	"./tima.png": "89ac",
	"./tima2.png": "87da",
	"./tima_app.png": "69bf",
	"./tima_bg1.png": "f1c6",
	"./tima_web.png": "93d9",
	"./vexere.png": "534c",
	"./vexere_web.png": "2b48",
	"./vib.png": "cbf7",
	"./vib_web.png": "5071",
	"./vietlott.png": "baf5",
	"./vntrip.png": "560c",
	"./vntrip_web.png": "d206",
	"./vp.png": "acbb",
	"./vp_1.png": "4bfc",
	"./vp_web.png": "234d",
	"./vp_web_2.png": "73b0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fde6";